
import { HttpHandler, HttpInterceptor, HttpRequest,HttpErrorResponse  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../guards/auth.service';
import { UrlService } from '../services/url.service';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

   exceptURLsList = ['authentication','graph.microsoft.com'];

  constructor(private authService: AuthService, private urlService: UrlService,private router: Router) { }
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    const TOKEN: string = this.authService.getToken();
    let authReq = req.clone();
    const requestURL = authReq.url.replace(this.urlService.getUrl(), '');
    
    if (TOKEN && this.exceptURLsList.indexOf(requestURL) === -1) {
      const requestHeaders = req.headers.set('Authorization', `Bearer ${TOKEN}`);
      authReq = req.clone({
        headers: requestHeaders
      });
    }

    // send cloned request with header to the next handler.
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          // Token is invalid or expired
          this.authService.clearSessionStorage(); // Clear session storage
          this.router.navigate(['/login']); // Redirect to login
        }
        return throwError(() => error); // Re-throw the error
      })
    );
  }

  getAPIToken() {
    // return DEV_TOKEN;
    // if(environment.production) {
    //     //return this.auth.API_TOKEN;
    // }
    // else {
    //     return DEV_TOKEN;
    // }
  }
}